import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {SelectItem} from "primeng/api";
import {Observable, of} from "rxjs";
import { SignerQualityEnum, TitleEnum, AuthTypeEnum, TypeBounceEnum } from '../../enums/dropdown.enums';

@Injectable({
  providedIn: 'root'
})
export class DropdownService {

  constructor(private translateService: TranslateService) {}

  getSignerQualityItems(): Observable<SelectItem[]> {
    return of([
      { label: this.translateService.instant('COMMON.SIGNER.COMPANY'), value: SignerQualityEnum.PROFESSIONAL },
      { label: this.translateService.instant('COMMON.SIGNER.INDIVIDUALS'), value: SignerQualityEnum.INDIVIDUAL }
    ]);
  }

  getTitleItems(): Observable<SelectItem[]> {
    return of([
      { label: this.translateService.instant('COMMON.DROPDOWN.TITLE_MR'), value: TitleEnum.MR },
      { label: this.translateService.instant('COMMON.DROPDOWN.TITLE_MME'), value: TitleEnum.MME }
    ]);
  }

  getAuthTypeItems(): Observable<SelectItem[]> {
    return of([
      { label: this.translateService.instant('COMMON.DROPDOWN.AUTHENTICATION_EMAIL'), value: AuthTypeEnum.EMAIL },
      { label: this.translateService.instant('COMMON.DROPDOWN.AUTHENTICATION_SMS'), value: AuthTypeEnum.SMS }
    ]);
  }

  getTypeBounceItems(): Observable<SelectItem[]> {
    return of([
      { label: this.translateService.instant('COMMON.DROPDOWN.BOUNCE_EXPIRED'), value: TypeBounceEnum.EXPIRED },
      { label: this.translateService.instant('COMMON.DROPDOWN.BOUNCE_REFUSED'), value: TypeBounceEnum.REFUSED },
      { label: this.translateService.instant('COMMON.DROPDOWN.BOUNCE_FAILED'), value: TypeBounceEnum.FAILED },
      { label: this.translateService.instant('COMMON.DROPDOWN.BOUNCE_DAY'), value: TypeBounceEnum.DAY }
    ]);
  }
}
